import { FormElement, FormId } from "../../../../components/enums";
import {
  ComplexFormSchemaComponents,
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { selectIncidentDamageData } from "../incident.selectors";

import { ComponentId } from "./enums";

export const form: FormSchema<
  ComplexFormSchemaComponents | SimpleFormSchemaComponents
> = {
  formId: FormId.INCIDENT_DAMAGE,
  selector: selectIncidentDamageData,
  content: [
    {
      title: "Uszkodzenia pojazdu",
      sections: [
        {
          id: "incident-damage-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.INCIDENT_DAMAGE_DESCRIPTION,
              required: true,
              placeholder:
                "Opisz uszkodzenia swojego pojazdu (np. pęknięty przedni zderzak, " +
                "wgniecenie na błotniku lewym przednim, odprysk na szybie przedniej, itp.)",
              limit: 1000,
              label: "Opis uszkodzeń",
            },
          ],
        },
        {
          id: "incident-damage-data-image-1",
          title: "Dodaj zdjęcia pojazdu w odpowiednie miejsce",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_SINGLE,
              id: ComponentId.INCIDENT_DAMAGE_FRONT_IMAGE,
              imageSectionId: ComponentId.INCIDENT_DAMAGE_IMAGES,
              imageId: ComponentId.INCIDENT_DAMAGE_FRONT_IMAGE,
              label:
                "Zdjęcie z przodu pojazdu po skosie, widoczna tablica rejestracyjna i bok.",
            },
            {
              type: FormElement.IMAGE_UPLOADER_SINGLE,
              id: ComponentId.INCIDENT_DAMAGE_BACK_IMAGE,
              imageSectionId: ComponentId.INCIDENT_DAMAGE_IMAGES,
              imageId: ComponentId.INCIDENT_DAMAGE_BACK_IMAGE,
              label:
                "Zdjęcie z tyłu pojazdu po skosie, widoczna tablica rejestracyjna i bok.",
            },
          ],
        },
        {
          id: "incident-damage-data-image-2",
          title:
            "Dodaj maksymalnie 10 szczegółowych zdjęć uszkodzeń pojazdu, numer VIN, uszkodzonych innych pojazdów, miejsce zdarzenia etc.",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_MULTIPLE,
              id: ComponentId.INCIDENT_DAMAGE_ADDITIONAL_IMAGES,
              maxImageNumber: 10,
              ignoredKeys: [
                ComponentId.INCIDENT_DAMAGE_FRONT_IMAGE,
                ComponentId.INCIDENT_DAMAGE_BACK_IMAGE,
              ],
              imageSectionId: ComponentId.INCIDENT_DAMAGE_ADDITIONAL_IMAGES,
            },
          ],
        },
      ],
    },
  ],
};
